module.exports = __webpack_public_path__ + "static/lights33-1fe7a472c1c30d68014c70f2ecc5dbe1.jpg";